import { render, staticRenderFns } from "./SpecimensByStatusModal.vue?vue&type=template&id=33bf2034"
import script from "./SpecimensByStatusModal.vue?vue&type=script&lang=js"
export * from "./SpecimensByStatusModal.vue?vue&type=script&lang=js"
import style0 from "./SpecimensByStatusModal.vue?vue&type=style&index=0&id=33bf2034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports